module.exports = __webpack_public_path__ + "img/2.35bd9a34.png";